import React, { useState } from "react";
import NavigationContext from "../context/navigationContext";

const NavigationProvider = ({ children }) => {
  // state variables
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState("");

  // some handler
  const handleToggleNavigation = (value = undefined) => {
    if (value !== undefined) setIsOpen(value);
    else setIsOpen((prev) => !prev);
  };

  const handleNavigateTo = (target) => {
    setCurrentPage(target);
  };

  // context value
  const contextValue = {
    isOpen,
    currentPage,
    navigateTo: handleNavigateTo,
    toggleNavigation: handleToggleNavigation,
  };

  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider;
